// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import FormEditor from './pages/FormEditor';
import FormsList from './pages/FormsList';
import Users from './pages/Users';
import Departments from './pages/Departments';
import Reports from './pages/Reports';
import BulkUpload from './pages/BulkUpload';

const Guard = ({ children, perm }) => {
  const { user, loading, can } = useAuth();
  if (loading) return <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',fontFamily:'Traditional Arabic,Arial',fontSize:16}}>⌛ چاوەڕوانبە...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (perm && !can(perm)) return <div style={{padding:40,fontFamily:'Traditional Arabic',fontSize:16,color:'#e74c3c'}}>⛔ مەرجی دەستوورت نیە</div>;
  return children;
};

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
      <Route path="/" element={<Guard><Layout /></Guard>}>
        <Route index element={<Dashboard />} />
        <Route path="forms" element={<FormsList />} />
        <Route path="forms/new" element={<Guard perm="create"><FormEditor /></Guard>} />
        <Route path="forms/:id" element={<FormEditor />} />
        <Route path="reports" element={<Guard perm="report"><Reports /></Guard>} />
        <Route path="bulk-upload" element={<Guard perm="manage"><BulkUpload /></Guard>} />
        <Route path="users" element={<Guard perm="manage"><Users /></Guard>} />
        <Route path="departments" element={<Guard perm="manage"><Departments /></Guard>} />
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-center" toastOptions={{
          style: { fontFamily:'Traditional Arabic,Arial,sans-serif', fontSize:14, direction:'rtl' }
        }} />
      </BrowserRouter>
    </AuthProvider>
  );
}
